import { render } from "./ViewsAcknowledgement.vue?vue&type=template&id=34965700"
import script from "./ViewsAcknowledgement.vue?vue&type=script&lang=js"
export * from "./ViewsAcknowledgement.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__